import React from 'react';
export function Footer() {
  return <footer className="border-t border-clay/15 bg-paper px-4 py-12" data-id="element-100" data-mp="32wd0e9mw79qd">
      <div className="mx-auto flex max-w-6xl flex-col items-center text-center" data-id="element-101" data-mp="3gfitoga0y7d2">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-clay-dark" data-id="element-102" data-mp="32o4c8dvrme84">Método Reconstrucción Interior™</p>
        <p className="mt-3 max-w-md text-sm leading-6 text-ink/60" data-id="element-103" data-mp="36ooaxlvzlpwd">
          Formación integral en inteligencia emocional y desarrollo personal.
        </p>
        <p className="mt-8 text-xs text-ink/45" data-id="element-104" data-mp="3ud7iu0b4k0nx">© 2026 Método Reconstrucción Interior. Todos los derechos reservados.</p>
      </div>
    </footer>;
}